export const CORP_LINK = 'https://techunited.co';

export const PENDING = 'pending';
export const APPROVED = 'accepted';
